export default __webpack_public_path__ + "static/media/img3.c55fd5ed.png";